import { useState } from "react";
import { Link } from "react-router-dom";

interface HeroSectionProps {
  onScrollToInput: () => void;
}

export const HeroSection = ({ onScrollToInput }: HeroSectionProps) => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
        Best AI Humanizer Tool - Humanize AI Text
      </h1>
      <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-8">
        Transform AI-generated content into natural, human-like writing instantly. Our <Link to="/best-ai-humanizer" className="text-primary hover:underline"><strong>best AI humanizer</strong></Link> tool 
        converts robotic text into engaging content that bypasses AI detection. <Link to="/ai-text-humanizer-free" className="text-primary hover:underline"><strong>Free AI text humanizer</strong></Link> with 
        unlimited usage - <Link to="/humanize-ai-text-online" className="text-primary hover:underline"><strong>humanize AI text online</strong></Link> and connect authentically with your readers.
      </p>
      
      {/* Video Demo - Optimized with thumbnail */}
      <div className="max-w-3xl mx-auto mb-12">
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          {!videoLoaded ? (
            <div 
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg bg-cover bg-center cursor-pointer group"
              style={{ backgroundImage: 'url(https://i3.ytimg.com/vi/gospKwmzxTk/maxresdefault.jpg)' }}
              onClick={() => setVideoLoaded(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setVideoLoaded(true)}
              aria-label="Play video demo of humanize AI text tool"
            >
              <div className="absolute inset-0 bg-black/30 rounded-lg flex items-center justify-center group-hover:bg-black/40 transition-colors">
                <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                  <svg className="w-8 h-8 text-red-600 ml-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
              src="https://www.youtube.com/embed/gospKwmzxTk"
              title="Free Humanize AI Text Tool Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          )}
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center mb-12">
        <h2 className="text-2xl font-bold mb-4">
          Start Using the <strong>Best AI Humanizer Tool</strong> Now
        </h2>
        <p className="text-muted-foreground mb-8 max-w-2xl mx-auto">
          Transform your AI content into natural, human-like writing in seconds. 
          Join thousands of users who trust our <Link to="/best-ai-humanizer" className="text-primary hover:underline"><strong>best AI humanizer</strong></Link> technology. 
          Try our <Link to="/ai-text-humanizer-free" className="text-primary hover:underline"><strong>free AI text humanizer</strong></Link> with unlimited usage!
        </p>
      </div>
    </div>
  );
};